'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const colorByIntent = (theme) => ({
    danger: theme.designTokens.iconIntentDangerColor,
    disabled: theme.designTokens.iconIntentDisabledColor,
    primary: theme.designTokens.iconIntentPrimaryColor,
    success: theme.designTokens.iconIntentSuccessColor,
    warning: theme.designTokens.iconIntentWarningColor,
});
const fontSizeByIconSize = (theme) => ({
    s: theme.designTokens.iconFontSizeS,
    m: theme.designTokens.iconDefaultFontSize,
    l: theme.designTokens.iconFontSizeL,
    xl: theme.designTokens.iconFontSizeXL,
});
const getIconSize = ({ theme, size }) => (size ? fontSizeByIconSize(theme)[size] : '1em');
const Container = styled__default.default.i `
  color: ${({ intent, theme }) => (intent ? colorByIntent(theme)[intent] : 'inherit')};
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
  font-size: ${getIconSize};
  height: ${getIconSize};
  width: ${getIconSize};
  > svg {
    display: block;
  }
`;
const Styled = {
    Container,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
